<template>
  <div>
    <div class="h-[100%] min-h-[100vh]">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
};
</script>
